<style scoped lang="scss">
.application-hero {
    background: #333;
}

    .mobile-program-container {
        padding-top: 16px;
        padding-bottom: 16px;
        padding-right: 24px;
        border: thin solid #999;
        border-radius: 8px;
        margin-bottom: 16px;
    }
</style>

<template>
    <div v-if="user">
        <div class="uk-container uk-container-center" id="section-loader">
            <div id="apply-area" class="uk-margin-large-bottom">
                <div class="uk-grid">
                    <div class="uk-width-9-10 uk-align-center">
                        <h2>{{ user.person.first_name }} {{ user.person.last_name }}'s Applications</h2>
                        <div class="uk-grid uk-hidden-medium uk-hidden-large mobile-program-container" v-for="application in user.household_applications">

                            <div class="uk-width-1-1 uk-text-bold uk-text-large">{{ application.program.program_name }}</div>
                            <div class="uk-width-1-1 uk-text-muted uk-text-small">APPLICATION #{{ application.id }}</div>
                            <div class="uk-width-1-1 uk-margin-small-top uk-text-bold">Status: {{ application.status.program_application_status_name }}</div>
                            <div class="uk-width-1-1 uk-margin-small-top" v-if="application.status.description">{{ application.status.description }}</div>
                            <div class="uk-width-1-1 uk-margin-top">
                                <div class="uk-grid uk-width-1-1 uk-margin-bottom">
                                    <router-link class="uk-button uk-width-1-1 uk-margin-bottom uk-button-primary uk-button-large" :to="'/application/'+application.id" v-if="application.status.id != 1 && application.status.allow_household_edit && application.status.id !== 15" >Edit Application</router-link>
                                    <router-link class="uk-button uk-width-1-1 uk-margin-bottom uk-button-primary uk-button-large" :to="'/application/'+application.id" v-if="application.status.id === 1" >Begin Application</router-link>
                                    <router-link class="uk-button uk-width-1-1 uk-margin-bottom " :to="'/'" v-if="application.status.id === 15">Waitlisted</router-link>
                                    <a :href="'/hope/prequal-letter/'+application.id" v-if="application.status.show_prequal_letter" class="uk-button uk-button-primary uk-width-1-1 uk-margin-top">PRE-QUALIFICATION LETTER</a>
                                </div>
                            </div>
                        </div>
                        <div class="uk-overflow-auto uk-hidden-small" style="overflow:scroll">
                            <table class="uk-table uk-table-striped">
                                <thead>
                                <tr>
                                    <th>Number</th>
                                    <th>Program</th>
                                    <th>Status</th>
                                    <th>Explanation</th>
                                    <th>Actions</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-for="application in user.household_applications">
                                    <td>
                                        {{ application.id }}

                                    </td>
                                    <td>{{ application.program.program_name }}</td>
                                    <td>
                                        <span class="status-name">{{ application.status.program_application_status_name}}</span>
                                    </td>
                                    <td>
                                        <span >{{application.status.description}}</span>
                                    </td>
                                    <td>
                                        <router-link :to="'/application/'+application.id" v-if="application.status.id != 1 && application.status.allow_household_edit && application.status.id !== 15" class="uk-button uk-button-primary uk-width-1-1 uk-margin-bottom">Edit Application</router-link>
                                        <router-link :to="'/application/'+application.id" v-if="application.status.id === 1" class="uk-button uk-button-primary uk-width-1-1 uk-margin-bottom">Begin Application</router-link>
                                        <router-link :to="'/'" v-if="application.status.id === 15" class="uk-button uk-button-primary uk-width-1-1 uk-margin-bottom">Waitlisted</router-link>
                                        <a :href="'/hope/prequal-letter/'+application.id" target="_blank" v-if="application.status.show_prequal_letter" class="uk-button uk-button-primary">PRE-QUALIFICATION LETTER</a>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>

                    </div>

                    <div class="uk-width-9-10 uk-align-center uk-margin-top" v-if="availablePrograms.length > 0">
                        <h2>Available Programs</h2>
                        <div class="uk-grid " >
                            <div class="uk-width-medium-1-3 uk-width-small-1-1 uk-margin-large-bottom program-container" v-for="program in availablePrograms">
                                <h2>{{ program.program_name }}</h2>
                                <h3 v-if="program.description">{{ program.description }}</h3>

                                <div v-if="program.logo_url" class="uk-margin-bottom">
                                    <img :src="program.logo_url" alt="">
                                </div>

                                <div>
                                    <button @click="createApplication(program)" class="uk-button uk-button-large uk-button-primary uk-width-1-1">
                                      <span v-if="program.open && program.max_applications > program.applications_count">APPLY</span>
                                      <span v-else-if="program.waitlist || (program.max_applications < program.applications_count && program.at_max_applications === 'wait')">JOIN WAIT LIST</span>
                                      <span v-else-if="!program.open || (program.max_applications < program.applications_count && program.at_max_applications === 'close')">MORE INFORMATION</span>
                                    </button>
                                </div>
                            </div>
                        </div>

                    </div>


                </div>

                <!-- <static-information></static-information> -->
            </div>

        </div>


        <!-- SITE FOOTER - CONVERT TO INCLUDE ON NON-LIGHT BOX PAGES -->
        <div class="uk-grid" data-uk-scrollspy="{cls:'uk-animation-fade', delay:1400}">
            <hr class="uk-hidden-medium uk-hidden-large uk-width-1-1 uk-margin-bottom">
            <div class="uk-width-1-1 uk-width-medium-2-10"><img
                    :src="env.PUBLIC_LOGO"
                    :alt="env.PROGRAM_NAME"></div>
            <hr class="uk-hidden-medium uk-hidden-large uk-width-1-1 uk-margin-bottom uk-margin-top">
            <div class="uk-width-medium-6-10">
                <h2><a :href="env.PUBLIC_PHONE">{{ env.PUBLIC_PHONE }}</a><br/>
                <small v-if="env.PUBLIC_FAX">FAX: {{ env.PUBLIC_FAX }}</small>
                </h2>
                <p>{{ env.AGENCY_NAME }} provides assistance on a fair and equal basis
                    regardless of race, color, religion, sex, familial status, national origin, military status,
                    disability or ancestry. Please visit <a :href="env.AGENCY_SITE" target="_blank"
                                                            class="uk-link-muted">{{ env.AGENCY_SITE }}</a> for more
                    information.</p>
            </div>
            <div class="uk-width-1-1  uk-margin-top uk-margin-bottom">
                <br/>&copy; 2020 <a :href="env.AGENCY_SITE" target="_blank">{{ env.AGENCY_NAME }}, All Rights
                Reserved</a>
                <ul class="uk-subnav uk-subnav-line uk-text-center">
                    <li><a :href="'/'+programs[0].slug+'/terms-of-use'" target="_blank">Terms of Use</a></li>
                    <li><a :href="'/'+programs[0].slug+'/terms-of-service'" target="_blank">Terms of Service &amp; Disclaimers</a></li>
                    <li><a :href="'/'+programs[0].slug+'/privacy-policy'" target="_blank">Privacy &amp; Security</a></li>
                </ul>
                <br/>
            </div>
        </div>


        <!-- BEGIN  Ready Definition Modal -->
        <div id="ready-definition" class="uk-modal">
            <div class="uk-modal-dialog"><a class="uk-modal-close uk-close"></a>
                <h2 class="uk-text-large">What does it mean to be "ready to upload"?</h2>
                <hr/>
                <p>

                <ul>
                    <li>Your documentation meets the date and content requirements;</li>
                    <li>You have your documentation available as a legible:
                        <ul>
                            <li>High resolution scan as a Jpeg, PNG, or PDF;</li>
                            <li>High resolution photo as a Jpeg or PNG;</li>
                            <li>Downloaded PDF from the original document provider</li>
                        </ul>
                    </li>
                    <li>You have either an email address or a cell phone number capable of receiving texts (data and
                        messaging rates from your provider apply);
                    </li>
                </ul>
                </p>
                <div class="uk-panel-box uk-alert-warning">
                    <div class="uk-grid">
                        <div class="uk-width-1-10"><i class="uk-icon-exclamation-circle"></i></div>
                        <div class="uk-width-9-10">It is important to check the legibility of your photos and/or scans
                            otherwise it can delay your application. Not sure if your documents are legible? <a
                                    href="#legibility-sample" data-uk-modal
                                    class="uk-button uk-button-mini uk-button-secondary"><i class="uk-icon-open"></i>
                                Click Here for an Example.</a>
                            <hr>
                        </div>
                    </div>
                    <div class="uk-grid">
                        <div class="uk-width-1-1">
                            <h3 class="uk-text-center">Have all your documents ready?</h3>

                            <a href="#document-check-list" data-uk-modal
                               class="uk-button uk-button uk-button uk-width-9-10 uk-width-small-1-1 uk-width-medium-2-3 uk-margin-bottom uk-align-center uk-animation-fade"><i
                                    class="uk-icon-check-square-o"></i> Document Checklist</a>

                        </div>


                    </div>
                </div>
            </div>
        </div>

        <!-- BEGIN Legibility Sample Modal -->
        <div id="legibility-sample" class="uk-modal">
            <div class="uk-modal-dialog"><a class="uk-modal-close uk-close"></a>
                <h2 class="uk-text-large">Below is a sample cropping of the same document:</h2>
                <hr/>
                <img src="/images/legibility-sample.jpg" alt="Sample of a legigible and illegible document.">
                <p class="uk-hidden-notouch uk-text-small uk-text-center">Pinch to zoom in.</p>
                <hr class="uk-grid-divider">
                <h2 class="uk-text-large uk-text-center">If you do not have the ability to get digital copies of your
                    documents - you can FAX them to {{ env.PUBLIC_FAX }}. </h2>
                <hr/>
                <p class="uk-text-center">Be sure to include your application number on your fax cover sheet</p>
                <div class="uk-grid">
                    <div class="uk-width-1-1">
                        <div class="uk-grid">
                            <div class="uk-width-4-10 uk-align-left">
                                <a href="#document-check-list" class="uk-button  uk-width-1-1" data-uk-modal><i
                                        class="uk-icon-check-square-o"></i> Document Checklist</a>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- BEGIN No Digital Copies Modal -->
        <div id="no-digital-copies" class="uk-modal">
            <div class="uk-modal-dialog"><a class="uk-modal-close uk-close"></a>
                <h2 class="uk-text-large">If you do not have the ability to get digital copies of your documents - you
                    can FAX them to {{ env.PUBLIC_FAX }}. </h2>
                <hr/>
                <p>Be sure to include your application number on your fax cover sheet</p>
                <p class="uk-hidden-notouch">Pinch to zoom in.</p>
            </div>
        </div>


        <!-- Begin Check List Modal -->
        <div id="document-check-list" class="uk-modal">
            <div class="uk-modal-dialog uk-modal-dialog-blank">
                <div id="document-list-box" class="uk-grid uk-flex-middle">
                    <div class=" uk-width-1-6 uk-width-medium-1-3 uk-height-1-1 uk-cover-background uk-row-first "
                         style="background-image: url('/images/home-top-bg-mobile.jpg'); background-color:#000; ">&nbsp;
                    </div>
                    <div class="uk-width-5-6 uk-width-medium-2-3 uk-height-1-1 uk-overflow-container ">
                        <div class="uk-grid-collapse">
                            <div class="uk-width-9-10 uk-align-left">
                                <h2 class="uk-text-center uk-margin-top">Documentation Checklist </h2>
                                <hr class="uk-width-1-1 uk-grid-divider"/>
                                <h4>Please make sure you have copies of all your required documents <a
                                        href="#ready-definition" class="uk-link-muted" data-uk-modal><i
                                        class="uk-icon-info-circle"></i>&nbsp;ready for uploading</a> or for faxing to
                                    {{ env.PUBLIC_FAX }}:</h4>
                                <hr class="uk-width-1-1 uk-grid-divider"/>
                            </div>
                        </div>
                        <hr class="uk-width-9-10 uk-margin-top uk-margin-bottom"/>
                        <div class="uk-grid">
                            <div class="uk-width-1-10 "><i class="uk-icon-square-o uk-icon-medium"></i></div>
                            <div class="uk-width-8-10 uk-margin-small-left"> Two approved proofs of citizenship and
                                identification for the Head of Household.
                            </div>
                        </div>
                        <hr class="uk-width-9-10 uk-margin-top uk-margin-bottom"/>
                        <div class="uk-grid">
                            <div class="uk-width-1-10 "><i class="uk-icon-square-o uk-icon-medium"></i></div>
                            <div class="uk-width-8-10 uk-margin-small-left"> Two approved proofs of residency for the
                                Head of Household.
                            </div>
                        </div>
                        <hr class="uk-width-9-10 uk-margin-top uk-margin-bottom"/>
                        <div class="uk-grid">
                            <div class="uk-width-1-10 "><i class="uk-icon-square-o uk-icon-medium"></i></div>
                            <div class="uk-width-8-10  uk-margin-small-left"> Last 12 months of mortgage statements
                                (Mortgage Programs), or copy of Signed Lease (Rental Programs).
                            </div>
                        </div>
                        <hr class="uk-width-9-10 uk-margin-top uk-margin-bottom"/>
                        <div class="uk-grid">
                            <div class="uk-width-1-10 "><i class="uk-icon-square-o uk-icon-medium"></i></div>
                            <div class="uk-width-8-10  uk-margin-small-left"> Copy of late notice, foreclosure notice,
                                shut-off notice, eviction, or 3 day notice.
                            </div>
                        </div>
                        <hr class="uk-width-9-10 uk-margin-top uk-margin-bottom"/>
                        <div class="uk-grid">
                            <div class="uk-width-1-10 "><i class="uk-icon-square-o uk-icon-medium"></i></div>
                            <div class="uk-width-8-10  uk-margin-small-left"> 30 days of household income (pay stubs or
                                receipts) for each household member 18 and older.
                            </div>
                        </div>
                        <hr class="uk-width-9-10 uk-margin-top uk-margin-bottom"/>
                        <div class="uk-grid">
                            <div class="uk-width-1-10 "><i class="uk-icon-square-o uk-icon-medium"></i></div>
                            <div class="uk-width-8-10  uk-margin-small-left"> A copy of your utility bill, if applying for
                                utility assistance.
                            </div>
                        </div>
                        <hr class="uk-width-9-10 uk-margin-top uk-margin-bottom"/>
                        <div class="uk-grid-collapse">
                            <div class="uk-width-9-10 uk-width-medium-6-10 uk-align-center uk-text-center">Do you have
                                all your documents ready?
                            </div>
                            <div class="uk-width-9-10 uk-width-medium-6-10 uk-align-center"><a href="#pre-qualify-form"
                                                                                               data-uk-modal
                                                                                               class="uk-button uk-button-primary uk-button-large uk-width-9-10 uk-width-1-1 uk-width-medium-2-3 uk-margin-bottom uk-align-center "><i
                                    class="uk-icon-pencil-square-o"></i> Click Here to Apply</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>




    </div>
</template>

<script>
    // var staticPage = "../components/Home/" + this.env.USE_LAYOUT_SET + "/StaticInformation";
    import {mapState} from 'vuex';
    import PublicHero from "../components/Home/PublicHero";
    //import StaticInformation from "../components/Home/lorain-co-oh/StaticInformation";
    import ApplicationRow from "../components/Home/ApplicationRow";

    export default {
        name: "HopeIndex",
        //components: {ApplicationRow, StaticInformation, PublicHero},
        components: {ApplicationRow, PublicHero},
        data() {
            return {
                process: process,
            }
        },
        computed: {
          tosUrl() {
            return '/'+this.programs[0].slug+'/terms-of-service'
          },
            /**
             * An Available Program can be anything that is not already applied to
             * or has a status of multiple_allowed
             */
            availablePrograms() {
                let programs = [];
                return programs;
                let currentProgramIds = _.map(this.user.household_applications, 'program_id');

                _.each(this.programs, program => {
                    if(currentProgramIds.includes(program.id) && !program.allow_multiple) {
                        return;
                    }

                    programs.push(program);
                })



                return programs;
            },
            ...mapState('App', {
                user: state => state.user,
                env: state => state.env,
                programs: state => state.programs,
            }),
            ...mapState('Application', {
                application: state => state.application,
            }),
        },
        methods: {
            /*
            Date Types:
                0 => 'No Date (disables setting)',
                1 => 'Date Last Applied',
                2 => 'Date Last Funding Approved',
                3 => 'Last Month of Assistance',
            */
            latestDateForPreviousProgramApplication(program, dateType) {
                let latestDate = null;
                _.each(this.user.applications, app => {

                })
            },
            async getPrograms() {
                let r = await axios.get('/api/hope/programs');
                this.$store.commit('App/SET_PROGRAMS', r.data);
            },

            /*
             * Creates a new application for the user for the program
             */
            createApplication(program) {
                axios.post('/api/hope/programs/'+program.id+'/create-application').then(res => {
                    this.$store.dispatch('App/fetchUser');
                    this.getPrograms();
                })
            },
        }
    }
</script>
